module.exports = __webpack_public_path__ + "static/media/contact-logo.1735d804.png";